import crypto from "crypto-js";

class CryptoJs {
  #key = process.env.REACT_APP_SECRET_KEY;

  /**
   * Encrypts Data
   * @param { object } data - Any Data
   * @returns
   */

  encryptData(data) {
    const encrypt = crypto.AES.encrypt(data, this.#key);
    return encrypt.toString();
  }

  /**
   * Decrypts Data
   * @param { object } data - Encrypted Data
   * @returns
   */

  decryptData(data) {
    const decrypt = crypto.AES.decrypt(data, this.#key);
    return decrypt.toString(crypto.enc.Utf8);
  }
}

const cryptoJs = new CryptoJs();
export default cryptoJs;
